import { Box, Grid, Skeleton } from '@factorialco/deprecated-design-system'

import { SectionComponentLayout } from 'modules/ats/pages/JobPostingSettings/SectionComponentLayout'

export const DescriptionSkeleton = () => {
  return (
    <SectionComponentLayout>
      <Skeleton height="s24" width="s140" />

      <Box gap="s16" paddingTop="s24" paddingBottom="s40">
        <Grid variant="fixed">
          {[...Array(2)].map((_, index) => (
            <Box gridColSpan={{ xxs: 1, xs: 6 }} key={`input-skeleton-${index}`}>
              <Skeleton height="s40" width="full" />
            </Box>
          ))}
        </Grid>
      </Box>

      <Box gap="s16" paddingTop="s24" paddingBottom="s40">
        <Skeleton height="s32" width="s120" />
        <Skeleton height="s240" width="full" />
      </Box>
    </SectionComponentLayout>
  )
}
